import * as React from 'react';

import { Card, CardContent } from '@/shared/ui/card';
import { Skeleton } from '@/shared/ui/skeleton';

import { DashboardGrid } from './dashboard-grid';

/**
 * Generic dashboard loading skeleton — five KPI placeholders + two big card
 * placeholders. Used for every dashboard's `isLoading` state.
 */
export function DashboardSkeleton() {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <DashboardGrid cols={5}>
        {Array.from({ length: 5 }).map((_, idx) => (
          <Card key={idx}>
            <CardContent className="tw-flex tw-flex-col tw-gap-3 tw-p-5">
              <Skeleton className="tw-h-9 tw-w-9 tw-rounded-lg" />
              <Skeleton className="tw-h-7 tw-w-24" />
              <Skeleton className="tw-h-3 tw-w-32" />
            </CardContent>
          </Card>
        ))}
      </DashboardGrid>

      <div className="tw-grid tw-grid-cols-1 tw-gap-4 lg:tw-grid-cols-3">
        <Card className="lg:tw-col-span-2">
          <CardContent className="tw-flex tw-flex-col tw-gap-3 tw-p-6">
            <Skeleton className="tw-h-5 tw-w-40" />
            <Skeleton className="tw-h-[280px] tw-w-full" />
          </CardContent>
        </Card>
        <Card>
          <CardContent className="tw-flex tw-flex-col tw-gap-3 tw-p-6">
            <Skeleton className="tw-h-5 tw-w-32" />
            <Skeleton className="tw-h-[60px] tw-w-full" />
            <Skeleton className="tw-h-[60px] tw-w-full" />
            <Skeleton className="tw-h-[60px] tw-w-full" />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
